/* All Ranges accordion in the mobile menu drawer (snippets/fi-drawer-ranges.liquid).
   Each [data-fi-dr-toggle] button opens or closes the element its aria-controls
   names. One delegated listener on the document, so a header re-rendered in the
   theme editor needs no re-init. */
(function () {
  var html = document.documentElement;
  if (html.hasAttribute('data-fi-dr-js')) return;
  html.setAttribute('data-fi-dr-js', '');

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fi-dr-toggle]');
    if (!button) return;
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  });
})();
